export const complianceStatusIcons = {
  success : "/dashboardIcons/done_all.svg",
  warning: "/dashboardIcons/error_outline.svg",
  error: "/dashboardIcons/warning.svg"
}
export const GET_COMPLIANCE_INITIAL_DATA = "GET_COMPLIANCE_INITIAL_DATA";
export const COMPLIANCE_LOADER = "COMPLIANCE_LOADER";
export const SET_COMPLIANCE_INITIAL_DATA = "SET_COMPLIANCE_INITIAL_DATA";
export const GET_COMPLIANCE_STATE_DATA = "GET_COMPLIANCE_STATE_DATA";
export const SET_COMPLIANCE_STATE_DATA = "SET_COMPLIANCE_STATE_DATA";
export const SET_PROCESSED_DATA = "SET_PROCESSED_DATA";
export const SET_SELECTED_SITE = "SET_SELECTED_SITE";

export const STATE_ABBR = {
  'Alabama': "AL",
  'Alaska': "AK",
  'Arizona': "AZ",
  'Arkansas': "AR",
  'California': "CA",
  'Colorado': "CO",
  'Connecticut': "CT",
  'Delaware': "DE",
  'Florida': "FL",
  'Georgia': "GA",
  'Hawaii': "HI",
  'Idaho': "ID",
  'Illinois': "IL",
  'Indiana': "IN",
  'Iowa': "IA",
  'Kansas': "KS",
  'Kentucky': "KY",
  'Louisiana': "LA",
  'Maine': "ME",
  'Maryland': "MD",
  'Massachusetts': "MA",
  'Michigan': "MI",
  'Minnesota': "MN",
  'Mississippi': "MS",
  'Missouri': "MO",
  'Montana': "MT",
  'Nebraska': "NE",
  'Nevada': "NV",
  'New Hampshire': "NH",
  'New Jersey': "NJ",
  'New Mexico': "NM",
  'New York': "NY",
  'North Carolina': "NC",
  'North Dakota': "ND",
  'Ohio': "OH",
  'Oklahoma': "OK",
  'Oregon': "OR",
  'Pennsylvania': "PA",
  'Rhode Island': "RI",
  'South Carolina': "SC",
  'South Dakota': "SD",
  'Tennessee': "TN",
  'Texas': "TX",
  'Utah': "UT",
  'Vermont': "VT",
  'Virginia': "VA",
  'Washington': "WA",
  'West Virginia': "WV",
  'Wisconsin': "WI",
  'Wyoming': "WY"
};
